import { useEffect } from 'react';

const Copernic = () => {
  // Plutot que d'intégrer le script et son container dans le DOM, on va injecter dynamiquement
  // le container et lancer le chargement du script. Cette solution permet de ne plus bloquer
  // l'initialisation de l'application en cas de lenteur des serveurs de Copernic, mais aussi
  // de fixer les erreurs d'hydration liées aux modifications du DOM effectuées par Copernic.
  useEffect(() => {
    // Si déjà existant, on ignore
    const copernicId = 'assistant-copernic';
    if (document.getElementById(copernicId)) return;
    // Création du container, et injection dans le DOM
    const container = document.createElement('div');
    container.setAttribute('id', copernicId);
    document.body.appendChild(container);
    // Chargement de Copernic
    const script = document.createElement('script');
    script.setAttribute('src', 'https://chat.copernic.co/widget.js');
    script.setAttribute('api-key', process.env.NEXT_PUBLIC_COPERNIC_KEY);
    document.head.appendChild(script);
  }, []);

  // Rien à afficher
  return null;
};

export default Copernic;
